import { render, staticRenderFns } from "./PurchaseConfirmation.vue?vue&type=template&id=cc67dc5e"
import script from "./PurchaseConfirmation.vue?vue&type=script&lang=js"
export * from "./PurchaseConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports